import { render, staticRenderFns } from "./detailDone.vue?vue&type=template&id=2f67e59a&scoped=true&"
import script from "./detailDone.vue?vue&type=script&lang=js&"
export * from "./detailDone.vue?vue&type=script&lang=js&"
import style0 from "./detailDone.vue?vue&type=style&index=0&id=2f67e59a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f67e59a",
  null
  
)

export default component.exports